import { LOAD_GROWTH_BY_HANDLE_START, LOAD_GROWTH_BY_HANDLE_SUCCESS, LOAD_GROWTH_BY_HANDLE_ERROR } from "./actions";

// Initial state
const initialState = {
    post: null,
    growthByHandle: [],
    loading: false,
    error: null,
};

// Reducer function
export const growth = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_GROWTH_BY_HANDLE_START:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case LOAD_GROWTH_BY_HANDLE_SUCCESS:
            return {
                ...state,
                growthByHandle: action.payload,
                loading: false,
                error: null,
            };
        case LOAD_GROWTH_BY_HANDLE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};